import {createStore} from "vuex";
import modules from "./modules";


export default createStore({
    state: {
        locale: localStorage.getItem('selectedLanguage') || 'da'
      },
      mutations: {
        SET_LOCALE(state, locale) {
          state.locale = locale;
          localStorage.setItem('selectedLanguage', locale);
          //Current method to reload the page
          window.location.reload();
          
        },
      },
      actions: {
        setLocale({ commit }, locale) {
          commit('SET_LOCALE', locale);
        },
      },
      modules,
      // Enable strict mode in development to get a warning
      // when mutating state outside of a mutation.
      // https://vuex.vuejs.org/guide/strict.html
      strict: process.env.NODE_ENV !== "production"
})

// Automatically run the `init` action for every module,
// if one exists.
for (const moduleName of Object.keys(modules)) {
    if (modules[moduleName].actions && modules[moduleName].actions.init) {
        this.dispatch(`${moduleName}/init`);
    }
}
